import { useSnapshot } from 'valtio';
import TopIssuesStore from '../stores/top-issues-store';
export { clearStore as clearTopIssuesStore } from '../store-actions/top-issues-store-actions';
export const useTopIssues = () => useSnapshot(TopIssuesStore);
